@if (customersLength() > 1 && currentCustomer(); as customer) {
  <div class="col-left">
    <ui-icon faName="location-dot" faStyle="light"></ui-icon>
    {{ customer.id }} -
    @if (customer.alias) {
      {{ customer.alias }}
    } @else {
      {{ customer.address?.streetAddress }}
    }
    <ui-icon-button
      buttonStyle="unthemed"
      icon="edit"
      iconStyle="light"
      title="Kundennummer wechseln"
      class="ml-xl"
      [class.small]="true"
      (click)="openDialog()"
    ></ui-icon-button>
  </div>
  <div class="col-right">
    <ui-icon faName="phone" faStyle="light"></ui-icon>
    <a href="tel:+4922349314444">02234/ 9314-444</a>
    <span class="x-divider">|</span>
    <ui-icon faName="envelope" faStyle="light"></ui-icon>
    <a href="mailto:digitalsupport@lekkerland.de">digitalsupport&#x40;lekkerland.de</a>
  </div>
}
